'use client';

import React from 'react';

export default function TypingIndicator() {
  return (
    <div className="flex items-end gap-2 mb-2 ml-1 animate-fade-in">
      {/* Avatar */}
      <div
        className="w-[34px] h-[34px] rounded-full flex items-center justify-center text-white font-bold text-[12px] flex-shrink-0"
        style={{ background: 'linear-gradient(135deg, #287FD8 0%, #6650D8 100%)' }}
        aria-label="Ate Boni avatar"
      >
        AB
      </div>
      {/* Typing bubble */}
      <div
        className="flex items-center gap-1.5 px-4 py-3 rounded-[18px] rounded-bl-[5px]"
        style={{ background: '#263548' }}
        aria-label="Ate Boni is typing"
        role="status"
      >
        <span className="w-[7px] h-[7px] rounded-full animate-bounce-dot" style={{ background: '#91A3B7', animationDelay: '0ms' }} />
        <span className="w-[7px] h-[7px] rounded-full animate-bounce-dot" style={{ background: '#91A3B7', animationDelay: '160ms' }} />
        <span className="w-[7px] h-[7px] rounded-full animate-bounce-dot" style={{ background: '#91A3B7', animationDelay: '320ms' }} />
      </div>
    </div>
  );
}